<template>
    <!-- Componente para mostrar la cotización de BBVA -->
    <div class="bbva-quotation bg-light-blue py-8 px-4 h-full shadow">
        <h3 class="font-medium text-xl lg:text-2xl text-center px-4 leading-tight lg:leading-normal sm:mt-2 text-white">
            BBVA Consumer Finance</h3>
        <div
            class="flex flex-col space-y-6 md:flex-row md:space-y-0 md:space-x-4 lg:flex-col lg:space-x-0 lg:space-y-6 xl:flex-row xl:space-y-0 xl:space-x-4 mt-8 md:mt-12 mb-8">
            <div class="text-center w-full md:w-1/3 lg:w-full xl:w-1/3 bg-white py-4">
                <p class="font-medium">Plazos</p>
                <p class="text-xl mt-2 xl:mt-4">{{instalments[instSelected]}} MESES</p>
                <p class="mt-2 xl:mt-4 text-sm">Tasa de Interés <span class="text-xs align-top">1</span> <br> {{tasa}}
                </p>
            </div>
            <div class="text-center w-full md:w-1/3 lg:w-full xl:w-1/3 bg-white py-4">
                <p class="font-medium">Pago Mensual <span class="text-xs align-top">2</span></p>
                <p class="text-xl mt-2 xl:mt-4">${{formatPrice(pagoMensual)}}</p>
                <p class="mt-2 xl:mt-4 text-sm">CAT {{cat}}%</p>
                <p class="text-sm -mt-1">SIN IVA <span class="text-xs align-top">3</span></p>
            </div>
            <div class="text-center w-full md:w-1/3 lg:w-full xl:w-1/3 bg-white py-4">
                <p class="font-medium">Financiamiento</p>
                <p class="text-xl mt-2 xl:mt-4">${{formatPrice(financiamiento)}}</p>
                <div class="mt-2 xl:mt-4 text-sm leading-tight">
                    <p>Total a Pagar</p>
                    <p>${{formatPrice(totalAPagar)}}</p>
                </div>
            </div>
        </div>
        <div class="px-12 mt-4 bg-white py-4">
            <p class="text-center font-medium">¿Quieres incluir el Seguro de Auto en esta simulación?..</p>
            <div class="flex justify-center space-x-4 mt-4">
                <button
                    class="w-20 rounded-2xl py-1"
                    :class="[
                        includeInsurance !== 'insu' && incInsuDisabled ? ['opacity-50', 'cursor-default'] : 'cursor-pointer',
                        includeInsurance === 'insu' ? ['bg-light-blue', 'text-white'] : ['bg-light-gray2', 'text-black']
                    ]"
                    @click="includeInsurance = 'insu'"
                    :disabled="incInsuDisabled"
                >
                    Sí
                </button>
                <button
                    class="w-20 rounded-2xl py-1"
                    :class="[
                        includeInsurance !== 'noInsu' && incInsuDisabled ? ['opacity-50', 'cursor-default'] : 'cursor-pointer',
                        includeInsurance === 'noInsu' ? ['bg-light-blue', 'text-white'] : ['bg-light-gray2', 'text-black']
                    ]"
                    @click="includeInsurance = 'noInsu'"
                    :disabled="incInsuDisabled"
                >
                    No
                </button>
                <!-- <label class="radio-container" :class="[includeInsurance !== 'insu' && incInsuDisabled ? ['opacity-75', 'cursor-default'] : 'cursor-pointer']">
                Sí
                <input type="radio" name="includeInsurance" :value="'insu'" v-model="includeInsurance" :disabled="incInsuDisabled">
                <span class="radio-checkmark"></span>
            </label>
            <label class="radio-container ml-12" :class="[includeInsurance !== 'noInsu' && incInsuDisabled ? ['opacity-75', 'cursor-default'] : 'cursor-pointer']">
                No
                <input type="radio" name="includeInsurance" :value="'noInsu'" v-model="includeInsurance" :disabled="incInsuDisabled">
                <span class="radio-checkmark"></span>
            </label> -->
            </div>
        </div>
        <div>
            <div class="text-center">
                <!-- Cambiar la siguiente linea si se ocupa la validación del click to buy para la descarga del PDF  -->
                <!-- <div v-if="clickToBuy"> -->
                    <div>
                    <!-- Componente para descargar la tabla de amortización sin llenar el formulario de Aplics -->
                    <bbva-table-btn-f2
                        :sub-name="dataTable.subName"
                        :model-name="dataTable.modelName"
                        :version-id="dataTable.versionId"
                        :version-name="dataTable.versionName"
                        :version-price="dataTable.versionPrice"
                        :model-year="dataTable.modelYear"
                        :term="dataTable.term"
                        :pago-mensual="pagoMensual"
                        :monto-total="financiamiento"
                        :total-pagar="totalAPagar"
                        :enganche="dataTable.downpayment"
                        :seguro="includeInsurance"
                        :bbva-app-id="bbvaAppId"
                        @loading="loadingTable = $event, incInsuDisabled = $event"
                    >
                    </bbva-table-btn-f2>


                            <a
                                class="w-56 xs:w-68 sm:w-88 hyundai-button-gray sm:text-base mx-auto mt-2 mb-8"
                                target="blank"
                                :href = "`${url}/${webpage}/modelos/formulario-cotizacion/${urlQuotation}`"

                            >
                                Solicitar cotización
                            </a>
                    <!-- Componente del botón para continuar con la pre autorización de crédito -->
                    <button v-if="clickToBuy"
                        class="w-56 xs:w-68 sm:w-88 hyundai-button sm:text-base mx-auto mt-2 mb-8"
                        :class="loadingTable ? 'opacity-75 cursor-default' : ''"
                        :disabled="loadingTable"
                        @click="chargeBbvaFormF2()"
                    >Solicita tu pre autorización de crédito digital</button>
                </div>
                <!-- Componente del botón para mostrar el formulario de Aplics para descargar la tabla de amortización si el modelo no tiene disponible el Click to buy -->
               
                <!-- Cambios solicitados el 16 de abril para descargar la tabla de amortizacion sin tener que llenar el formulario -->
                <!-- Descomentar la linea siguiente si se requiere la validación del formulario de nuevo -->
                <!-- <button
                    v-else
                    class="w-56 xs:w-68 sm:w-88 hyundai-button sm:text-base mx-auto my-8"
                    @click="chargeBbvaForm()"
                >Descarga tu Tabla de Pagos (Amortización)</button> -->
            </div>
            <div class="mt-2 text-sm">
                <p>1. <span class="font-medium">Tasa de interés fija del {{tasa}}% anual.</span></p>
                <p>2. El pago mensual no incluye IVA ni comisiones.</p>
                <p>3. <span class="font-medium">CAT {{cat}}%</span> Sin IVA. Informativo. <span
                        class="font-medium">Fecha de cálculo:</span> {{momentDate.format('DD/MM/YYYY')}}. <span
                        class="font-medium"
                    >Vigencia de la oferta:</span> {{momentDate.format('DD/MM/YYYY')}}.</p>
                <p>4. <span>Consulta términos, condiciones y requisitos de contratación del crédito
                    automotriz Consumer Finance en <a
                        class="underline"
                        href="https://www.bbva.mx/personas/productos/creditos/credito-auto.html"
                        target="_blank"
                    ><span class="font-medium">BBVA.mx</span></a></span></p>
            </div>
            <div class="mt-4">
                <!-- <p class="text-sm">Consulta términos, condiciones y requisitos de contratación del crédito automotriz
                    Consumer Finance en <a
                        class="underline"
                        href="https://www.bbva.mx/personas/productos/creditos/credito-auto.html"
                        target="_blank"
                    >BBVA.mx</a></p> -->
                <!-- <label class="checkbox-container ml-16">Acepto los Términos y condiciones de la Política de privacidad
                <input type="checkbox">
                <span class="checkmark"></span>
            </label> -->
            </div>
            <div
                v-if="includeInsurance === 'insu'"
                class="mt-4 text-sm"
            >
                <p>
                    Comisión por apertura 0.00% sobre el monto a financiar (pago único al inicio) no incluye IVA. El 
                    pago incluye un seguro de vida, el cual cubre el saldo insoluto del crédito en caso de 
                    fallecimiento. Sí lo contratas con BBVA su costo es de $4.200 financiados en el monto del crédito. 
                    Si decides contratarlo con otra aseguradora deberá cumplir con las condiciones de cobertura y 
                    presentar la póliza y el pago de la misma al momento de contratar el crédito.
                </p>
                <p class="mt-2">
                    Este documento es para efectos informativos y no constituye obligación u ofrecimiento formal por 
                    parte de BBVA México, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA México en el 
                    otorgamiento del crédito. Las condiciones de los créditos estarán sujetas a cambio sin previo aviso. 
                    Consulta términos, condiciones, comisiones y requisitos de contratación del crédito automotriz
                    Consumer Finance en <a
                        class="underline"
                        href="https://www.bbva.mx/personas/productos/creditos/credito-auto.html"
                        target="_blank"
                    >bbva.mx</a>
                </p>
                <p class="mt-2">
                    Aplican restricciones.
                </p>
            </div>
            <div
                v-else
                class="mt-4 text-sm"
            >
                <p>
                    Este crédito de auto requiere un seguro de daños como el cual no se encuentra contemplado en esta
                    simulación.
                </p>
                <p class="mt-2">
                    Comisión por apertura 0.00% sobre el monto a financiar (pago único al inicio) no incluye IVA. El
                    pago incluye un seguro de vida, el cual cubre el saldo insoluto del crédito en caso de
                    fallecimiento. Sí lo contratas con BBVA su costo es de $4.200 financiados en el monto del crédito.
                    Si decides contratarlo con otra aseguradora deberá cumplir con las condiciones de cobertura y
                    presentar la póliza y el pago de la misma al momento de contratar el crédito.
                </p>
                <p class="mt-2">
                    Este documento es para efectos informativos y no constituye obligación u ofrecimiento formal por
                    parte de BBVA México, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA México en el
                    otorgamiento del crédito. Las condiciones de los créditos estarán sujetas a cambio sin previo aviso.
                    Consulta términos, condiciones, comisiones y requisitos de contratación del crédito automotriz
                    Consumer Finance en <a
                        class="underline"
                        href="https://www.bbva.mx/personas/productos/creditos/credito-auto.html"
                        target="_blank"
                    >bbva.mx</a>
                </p>
                <p class="mt-2">
                    Aplican restricciones.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    props: [
        "instalments",
        "instSelected",
        "bbvaQuotation",
        "versionId",
        "clickToBuy",
        "subsidiary",
        "isIframe",
        "dataTable",
        "bbvaAppId",
        "subsidiaryWebpage",
        "inteColor",
        "extColor",
        "image",
    ],
    data() {
        return {
            url: $(".url").text(),
            webpage: $(".webpage").text(),
            // Variable para determinar si incluir el seguro de gastos
            // en la simulación o no
            includeInsurance: "noInsu",
            // Variable para determinar si se habilita el poder
            // seleccionar entre incluir el seguro de gastos en
            // la simulación
            incInsuDisabled: true,
            // Variable para determinar si está cargando la tabla
            // de pagos de la simulación
            loadingTable: false,
            
            // urlWebpage
            urlDistribuitor: this.subsidiaryWebpage,
            // urlDistribuitor: ( this.webpage && this.webpage.length > 0 ) ? this.webpage :  $( "#subsidiaries option:selected" ).text(), 
        };
    },


    watch: {
        // Observa la variable includeInsurance para emitir
        // el evento correspondiente cuando cambia el valor
        includeInsurance: function (newVal) {
            this.$eventBus.$emit("includeInsuranceChanged", newVal);
        },

        subsidiaryWebpage: function (newVal) {
            // console.log('actualizando valor',newVal);
            // if(this.webpage && this.webpage == ''  || this.webpage.length == 0 ){
                this.webpage = newVal;
            //}
            
        },
        // Observa la variable instSelected para determinar si
        // está disponible el seguro de gastos para el plazo seleccionado
        instSelected: function (newVal) {
            console.log('control de cambios componente bbva',newVal)
            if (newVal !== null) {
                // se cambio a noInsur
                this.includeInsurance = "noInsu";
                // Si el plazo seleccionado con seguro está disponible
                // pero no hay plazos disponibles sin seguro
                // o el plazo seleccionado sin seguro no está disponible
                // deshabilita los botones para evitar un error
                // y muestra solo la opción con segurro
                if (this.bbvaQuotation['insu'][this.instSelected]) {

                    if (this.bbvaQuotation['noInsu'].length > 0) {
                        if (this.bbvaQuotation['noInsu'][this.instSelected] !== undefined && (this.bbvaQuotation['insu'][this.instSelected] == undefined || this.bbvaQuotation['insu'][this.instSelected] == false)) {
                            this.incInsuDisabled = true;
                            console.log('Entro al primer if')
                        } else if(this.bbvaQuotation['noInsu'][this.instSelected] !== undefined && this.bbvaQuotation['insu'][this.instSelected] !== undefined){
                            this.incInsuDisabled = false;
                        }
                    } else {
                        this.incInsuDisabled = true;
                    }
                }
                // Si no está disponible el plazo seleccionado con seguro
                // deshabilita los botones y muestra la opción sin seguro
                // pero en caso de que ninguna opción esté disponible
                // emite un error al componente padre para mostrar un mensaje al usuario
                else {
                    this.includeInsurance = "noInsu";
                    this.incInsuDisabled = false;
                    if (!this.bbvaQuotation["noInsu"][this.instSelected]) {
                        this.$emit("bad-instalment");
                    }
                }
            }
        },
    },
    methods: {
  
        // Función para formatear el precio
        formatPrice(price) {
            return parseInt(price)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        },
        // Función para cargar el formulario de Aplics para
        // descargar la tabla de amortización si el modelo no
        // tiene disponible la opción de Click to buy
        chargeBbvaForm() {
            const quotData = {
                pagoMensual: this.pagoMensual,
                montoTotal: this.financiamiento,
                totalAPagar: this.totalAPagar,
                seguro: this.includeInsurance,
            };
            this.$emit("charge-bbva-form", quotData);
        },
        // Función para cargar el formulario de pre autorización
        // de crédito para los modelos con Click to buy
        chargeBbvaFormF2() {
            const quotData = {
                quotId: this.quotId,
                pagoMensual: this.pagoMensual,
                montoTotal: this.financiamiento,
                totalAPagar: this.totalAPagar,
                isIframe: this.isIframe,
            };
            this.$emit("charge-bbva-form-f2", quotData);
        },
    },
    computed: {
        urlQuotation(){
            let without = this.dataTable.modelName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            let model= without.replaceAll(" ","-")
            let version = this.dataTable.versionName.replaceAll(" ", "-")

            let fullText =  `${model.toLowerCase()}/${version.toLowerCase()}/${this.dataTable.modelYear}/${this.isIframe}/0/${this.dataTable.downpayment}/${this.pagoMensual}/${this.instalments[this.instSelected]}/${this.inteColor}/${this.extColor}/${btoa(this.image)}/${this.financiamiento}/${this.totalAPagar}`
            return fullText
        },

           

        // term() {
        //     let term = ''
        //     switch(this.instSelected) {
        //         case 0:
        //             term = 't12'
        //             break
        //         case 1:
        //             term = 't24'
        //             break
        //         case 2:
        //             term = 't36'
        //             break
        //         case 3:
        //             term = 't48'
        //             break
        //         case 4:
        //             term = 't60'
        //             break
        //         case 5:
        //             term = 't72'
        //             break

        //     }
        //     return term
        // },
        // Retorna los plazos disponbiles de acuerdo con la opción
        // incluir el seguro de gastos seleccionada
        bbvaInstallments() {
            console.log('Return *******', this.includeInsurance)
            return this.bbvaQuotation[this.includeInsurance];
        },
        // Retorna la tasa de interés de acuerdo con el plazo
        // seleccionado si está disponible
        tasa() {
            if (!$.isEmptyObject(this.bbvaInstallments))
                return this.bbvaInstallments[this.instSelected]
                    ? this.bbvaInstallments[this.instSelected].rates[0].unit
                        .percentage
                    : 0;
            else return 0;
        },
        // Retorna el pago mensual de acuerdo con el plazo
        // seleccionado si está disponible
        pagoMensual() {
            if (!$.isEmptyObject(this.bbvaInstallments))
                return this.bbvaInstallments[this.instSelected]
                    ? this.bbvaInstallments[this.instSelected].installmentPlan
                        .installmentAmount.amount
                    : 0;
            else return 0;
        },
        // Retorna el cat de acuerdo con el plazo
        // seleccionado si está disponible
        cat() {
            if (!$.isEmptyObject(this.bbvaInstallments))
                return this.bbvaInstallments[this.instSelected]
                    ? this.bbvaInstallments[this.instSelected].rates[1].unit
                        .percentage
                    : 0;
            else return 0;
        },
        // Retorna el financiamiento de acuerdo con el plazo
        // seleccionado si está disponible
        financiamiento() {
            if (!$.isEmptyObject(this.bbvaInstallments))
                return this.bbvaInstallments[this.instSelected]
                    ? this.bbvaInstallments[this.instSelected].requestedAmount
                        .amount
                    : 0;
            else return 0;
        },
        // Retorna el total a pagar de acuerdo con el plazo
        // seleccionado si está disponible
        totalAPagar() {
            if (!$.isEmptyObject(this.bbvaInstallments)){

            
                console.log('Seleccioando : ', this.instSelected);
                console.log('bbvaInstallments : ', this.bbvaInstallments);
                return this.bbvaInstallments[this.instSelected]
                    ? this.bbvaInstallments[this.instSelected].totalAmount
                        .amount
                    : 0;
            } else return 0;
        },
        // Retorna el id de cotización de acuerdo con el plazo
        // seleccionado si está disponible
        quotId() {
            if (!$.isEmptyObject(this.bbvaInstallments))
                return this.bbvaInstallments[this.instSelected]
                    ? this.bbvaInstallments[this.instSelected].bbvaQuotationId
                    : null;
            else return null;
        },
        // Retorna una instancia de moment para mostrar las fechas
        momentDate() {
            return moment();
        },
    },
};
</script>

<style lang="scss">
.bbva-quotation {
    .radio-container {
        display: block;
        position: relative;
        padding-left: 2.5rem;
        /* margin-bottom: 12px; */
        // cursor: pointer;
        /* font-size: 22px; */
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default radio button */
    .radio-container input {
        position: absolute;
        opacity: 0;
        // cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom radio button */
    .radio-checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 1.5rem;
        width: 1.5rem;
        background-color: #ededed;
        // border-radius: 50%;
        // border: 1px solid #000;
    }

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .radio-checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .radio-container input:checked~.radio-checkmark:after {
        display: block;
    }

    /* Style the indicator (dot/circle) */
    .radio-container .radio-checkmark:after {
        left: 7px;
        top: 1px;
        width: 10px;
        height: 18px;
        border: solid #00aad2;
        border-width: 0 4px 4px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
}
</style>
